import { TableCell, TableRow } from '@mui/material';
import { ReactElement } from 'react';
import { RecordContextProvider, ReferenceField, TextField } from 'react-admin';
import type { MerchantsOfferSummariesResource } from '../../../../../Entities/MerchantsOfferSummary';
import MetricCell from './MetricCell';

export default function MerchantRows({
  record,
}: {
  record: MerchantsOfferSummariesResource;
}): ReactElement {
  return (
    <>
      <TableRow>
        <TableCell
          rowSpan={4}
          sx={{
            verticalAlign: 'middle',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            bgcolor: 'background.paper',
          }}
        >
          {record.id === 'totals' ? (
            'Totals'
          ) : (
            <RecordContextProvider value={record}>
              <ReferenceField source="relationships.merchant.data.id" reference="merchants">
                <TextField source="attributes.merchant_name" />
              </ReferenceField>
            </RecordContextProvider>
          )}
        </TableCell>
        <MetricCell
          rowSpan={4}
          record={record}
          source="total_offers"
          metricKey="total_offers"
          highlightOnHover={false}
          sx={{ verticalAlign: 'middle' }}
        />
        <MetricCell
          rowSpan={4}
          record={record}
          source="categorized_offers"
          metricKey="categorized_offers"
          highlightOnHover={false}
          sx={{ verticalAlign: 'middle' }}
        />
        <MetricCell
          rowSpan={4}
          record={record}
          source="not_categorized_offers"
          metricKey="not_categorized_offers"
          highlightOnHover={false}
          sx={{ verticalAlign: 'middle' }}
        />
        <MetricCell
          rowSpan={4}
          record={record}
          source="comparable_offers"
          metricKey="comparable_offers"
          highlightOnHover={false}
          sx={{ verticalAlign: 'middle' }}
        />
        <MetricCell
          rowSpan={4}
          record={record}
          source="incomparable_offers"
          metricKey="incomparable_offers"
          highlightOnHover={false}
          sx={{ verticalAlign: 'middle' }}
        />
        <MetricCell
          rowSpan={4}
          record={record}
          source="combined_offers"
          metricKey="combined_offers"
          highlightOnHover={false}
          sx={{ verticalAlign: 'middle' }}
        />
        <MetricCell
          rowSpan={4}
          record={record}
          source="not_combined_offers"
          metricKey="not_combined_offers"
          highlightOnHover={false}
          sx={{ verticalAlign: 'middle' }}
        />
        <MetricCell
          colSpan={4}
          record={record}
          source="approved_offers"
          metricKey="approved_offers"
        />
        <MetricCell
          colSpan={4}
          record={record}
          source="disapproved_offers"
          metricKey="disapproved_offers"
        />
      </TableRow>
      <TableRow>
        <MetricCell
          colSpan={3}
          record={record}
          source="approved_categorized_offers"
          metricKey="approved_categorized_offers"
        />
        <MetricCell
          record={record}
          source="approved_not_categorized_offers"
          metricKey="approved_not_categorized_offers"
        />
        <MetricCell
          colSpan={3}
          record={record}
          source="disapproved_categorized_offers"
          metricKey="disapproved_categorized_offers"
        />
        <MetricCell
          record={record}
          source="disapproved_not_categorized_offers"
          metricKey="disapproved_not_categorized_offers"
        />
      </TableRow>
      <TableRow>
        <MetricCell
          colSpan={2}
          record={record}
          source="approved_categorized_comparable_offers"
          metricKey="approved_categorized_comparable_offers"
        />
        <MetricCell
          record={record}
          source="approved_categorized_incomparable_offers"
          metricKey="approved_categorized_incomparable_offers"
        />
        <TableCell />
        <MetricCell
          colSpan={2}
          record={record}
          source="disapproved_categorized_comparable_offers"
          metricKey="disapproved_categorized_comparable_offers"
        />
        <MetricCell
          record={record}
          source="disapproved_categorized_incomparable_offers"
          metricKey="disapproved_categorized_incomparable_offers"
        />
        <TableCell />
      </TableRow>
      <TableRow>
        <MetricCell
          record={record}
          source="approved_categorized_comparable_combined_offers"
          metricKey="approved_categorized_comparable_combined_offers"
        />
        <MetricCell
          record={record}
          source="approved_categorized_comparable_not_combined_offers"
          metricKey="approved_categorized_comparable_not_combined_offers"
        />
        <TableCell />
        <TableCell />
        <MetricCell
          record={record}
          source="disapproved_categorized_comparable_combined_offers"
          metricKey="disapproved_categorized_comparable_combined_offers"
        />
        <MetricCell
          record={record}
          source="disapproved_categorized_comparable_not_combined_offers"
          metricKey="disapproved_categorized_comparable_not_combined_offers"
        />
        <TableCell />
        <TableCell />
      </TableRow>
    </>
  );
}
